// extracted by mini-css-extract-plugin
module.exports = {"profileMenu":"NavbarDashboard_profileMenu__S2ijX","menuIcon":"NavbarDashboard_menuIcon__2pDxx"};